module.exports = __webpack_public_path__ + "5c114213/img/placeholder.888fcd0b.svg";